import { formatNumberWithSymbol } from "@/utils/number";
import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function numberRenderer({
  value,
  obj,
  isOldValue,
}: RenderProps) {
  const displayValue = Array.isArray(value)
    ? (value as Array<string | number>).join(", ")
    : formatNumberWithSymbol(value, obj.config?.number_format);
  return <ValueDisplay isOldValue={isOldValue}>{displayValue}</ValueDisplay>;
}
